// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBuildingBank } from '@tabler/icons';

const organization = {
    id: 'organization',
    title: <FormattedMessage id="organization" />,
    icon: IconBuildingBank,
    type: 'group',
    url: 'organization',
    roles: ['admin', 'ca']
};

export default organization;
